import { render, staticRenderFns } from "./TravelOrder.vue?vue&type=template&id=640f44ed&"
import script from "./TravelOrder.vue?vue&type=script&lang=js&"
export * from "./TravelOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports